import { MapTo } from '@adobe/aem-react-editable-components';
import Button, { CTATextEditConfig } from './Button';

export default MapTo('cob-corp-acquisition/components/creditonebank/button')(Button, CTATextEditConfig);